import flatpickr from "flatpickr";
import 'flatpickr/dist/flatpickr.css';
import { Portuguese } from "flatpickr/dist/l10n/pt.js";

document.addEventListener('turbo:load', function() {
  // Date picker - exibe formato brasileiro mas salva formato internacional
  flatpickr("[data-datePicker]", {
    enableTime: false,
    dateFormat: "Y-m-d",      // Formato salvo no campo (internacional)
    altInput: true,           // Habilita campo alternativo para exibição
    altFormat: "d/m/Y",       // Formato exibido para o usuário (brasileiro)
    locale: Portuguese,
    allowInput: true,
    disableMobile: true,
  });
  
  // DateTime picker - exibe formato brasileiro mas salva formato ISO
  flatpickr("[data-dateTimePicker]", {
    enableTime: true,
    dateFormat: "Y-m-d H:i",  // Formato salvo no campo (ISO)
    altInput: true,           // Habilita campo alternativo para exibição
    altFormat: "d/m/Y H:i",   // Formato exibido para o usuário (brasileiro)
    locale: Portuguese,
    allowInput: true,
    disableMobile: true,
  });
  
  // Time picker - apenas hora (sem data)
  flatpickr("[data-timePicker]", {
    enableTime: true,
    noCalendar: true,         // Remove o calendário, apenas hora
    dateFormat: "H:i",        // Formato salvo no campo (24h)
    altInput: true,           // Habilita campo alternativo para exibição
    altFormat: "H:i",         // Formato exibido (mesmo formato)
    locale: Portuguese,
    allowInput: true,
    disableMobile: true,
    time_24hr: true,          // Formato 24 horas
  });
});